import { WelcomeBanner } from '../components/WelcomeBanner';
import { useWelcomeBannerService } from '../services/useWelcomeBannerService';

export const WelcomeBannerContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const service = useWelcomeBannerService();

  if (!service.title) {
    return null;
  }

  return (
    <div ref={service.ref}>
      <WelcomeBanner
        backgroundColor={service.backgroundColor}
        highlightColor={service.highlightColor}
        title={service.title}
        guideText={service.guideText}
        onClick={service.handleClick}
      />
    </div>
  );
};
